<template>
  <v-card class="pa-6">
    <v-form ref="form">
      <DatasetFields :dataset="dataset" :editor-ready="loaded" @update="updateField" />
      <div class="text-center mt-6">
        <v-btn text @click="$router.back()"><v-icon left>mdi-arrow-left</v-icon>{{ $t("button.back") }}</v-btn>
        <v-btn color="primary" class="ml-2" @click="save"><v-icon left>mdi-content-save</v-icon>{{ $t("button.save") }}</v-btn>
      </div>
    </v-form>
  </v-card>
</template>
<script>
import axios from "axios";
import DatasetFields from "@/components/datasets/DatasetFields.vue";
import { createDefaultDataset, normalizeDataset, serializeDataset } from "@/utils/dataset";

export default {
  name: "EditDatasetDetail",
  components: { DatasetFields },
  data: () => ({ dataset: createDefaultDataset(), loaded: false }),
  created() {
    if (this.$route.params.id > -1) {
      axios.get(`${this.$store.state.endpoint}/dataset/${this.$route.params.id}`)
        .then(response => { this.dataset = normalizeDataset(response.data); })
        .catch(error => console.error(error)).finally(() => { this.loaded = true; });
    } else this.loaded = true;
  },
  methods: {
    updateField(field, value) { this.$set(this.dataset, field, value); },
    save() {
      if (!this.$refs.form.validate()) return;
      const editing = this.$route.params.id > -1;
      axios({
        method: editing ? "patch" : "post",
        url: editing
          ? `${this.$store.state.endpoint}/dataset/${this.$route.params.id}`
          : `${this.$store.state.endpoint}/dataset`,
        data: serializeDataset(this.dataset)
      }).then(() => {
        this.$store.commit("alert", { color: "success", text: this.$t(editing ? "message.correct.updateItem" : "message.correct.createItem") });
        this.$router.push("/manage/edit/datasets");
      }).catch(error => this.$store.commit("alert", { color: "error", text: error.response ? error.response.data : error.message }));
    }
  }
};
</script>
